/**
 * @fileoverview 文字列操作 util
 */
'use strict';
// Library Import
import _ from 'lodash';
// Util Import
import * as ConstUtil from './ConstUtil';

/**
 * 車両番号テキスト作成
 * @name createCarNumberText
 * @function
 * @memberof Content
 * @param {object} carNo
 * @returns {string} 車両番号
 */
export const createCarNumberText = carNo => {
  let car_no = '';
  // 車両番号が存在しない場合
  if (_.isEmpty(carNo)) {
    return '';
  }
  // 陸運支局が存在する場合
  if (!_.isEmpty(carNo.plate_area)) {
    car_no = car_no + carNo.plate_area + ' ';
  }
  // 用途コードが存在する場合
  if (!_.isEmpty(carNo.plate_kana)) {
    car_no = car_no + carNo.plate_kana + ' ';
  }
  // 分類番号が存在する場合
  if (!_.isEmpty(carNo.plate_type)) {
    car_no = car_no + carNo.plate_type + ' ';
  }
  // 一連番号が空の場合
  if (_.isEmpty(carNo.plate_number)) {
    return '';
  }
  // 車両番号テキスト作成
  return (
    car_no +
    createCarPlateNumberText(carNo.plate_number)
  );
};

/**
 * 車両番号 一連番号テキスト作成
 *
 * @param {String} plateNo 一連番号
 * @returns {String} 一連番号の表示用テキスト
 */
export const createCarPlateNumberText = plateNo => {
  let plateNoText = '';
  // plateNo = plateNo.trim();
  switch (plateNo.length) {
    case 1:
      // ・は半角
      plateNoText = '･･ ･' + plateNo;
      break;
    case 2:
      // ・は半角
      plateNoText = '･･ ' + plateNo;
      break;
    case 3:
      // ・は半角
      plateNoText = '･ ' + plateNo;
      break;
    case 4:
      // 4桁のみ‐つなぎ
      plateNoText = plateNo.slice(0, 2) + '-' + plateNo.slice(2);
      break;
    default:
      break;
  }
  return plateNoText;
};

/**
 * クエリパラメータ作成
 *
 * @param {Array}} params パラメータリスト
 * @returns {String} クエリパラメータ文字列
 */
export const createQueryParam = params => {
  // 初期値
  let queryString = ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.QUESTION_MARK;
  // クエリパラメータ文字列生成
  for (let param of params) {
    queryString +=
      param.key +
      ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.EQUAL +
      btoa(encodeURIComponent(param.value)) +
      ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.AND;
  }
  // 最終の「&」を削除
  return queryString.slice(0, -1);
};

/**
 * クエリパラメータ取得
 *
 * @returns {String}  クエリパラメータ値
 */
export const getQueryParams = key => {
  let hash = window.location.hash;
  let index = hash.indexOf(
    ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.QUESTION_MARK
  );
  // hashにクエリパラメータが存在しない場合
  if (index === -1) {
    return '';
  }
  // '?'以降を取得
  let queryString = hash.slice(index + 1);
  // '&'で分割
  let stringArray = queryString.split(
    ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.AND
  );
  // 1パラメータを連想配列に変換
  let paramsArray = [];
  for (let string of stringArray) {
    paramsArray.push({
      key: getQueryKey(string),
      value: getQueryValue(string)
    });
  }
  let params = _.find(paramsArray, { key: key });
  if (_.isEmpty(params)) {
    return '';
  }
  return params.value;
};

/**
 * クエリパラメータのキー取得
 *
 * @param {String} param パラメータ
 * @returns {String} キー
 */
export const getQueryKey = param => {
  let index = param.indexOf(ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.EQUAL);
  if (index === -1) {
    return '';
  }
  return param.slice(0, index);
};

/**
 * クエリパラメータの値取得
 *
 * @param {String} param パラメータ
 * @returns {String} 値
 */
export const getQueryValue = param => {
  let index = param.indexOf(ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.EQUAL);
  if (index === -1) {
    return '';
  }
  return decodeURIComponent(atob(param.slice(index + 1)));
};

/**
 * 日付フォーマット変換(yyyy/mm/ddThh:MM -> yyyy/mm/dd hh:MM)
 * @param {String} datetime 
 */
export const DateTimeLocalFormat = datetime => {
  return datetime.replace("T", " ");
}

/**
 * 日付フォーマット変換(yyyy/mm/dd hh:MM -> yyyy-mm-ddThh:MM)
 * @param {String} datetime 
 */
export const DateTimeFormat = datetime => {
  let date_time = datetime.replace("/", "-").replace("/", "-");
  date_time = date_time.replace(" ", "T");

  return date_time;
}


// WEBPACK FOOTER //
// ./src/js/util/StringUtil.jsx